var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "report-category" },
    [
      _c("toggle-button", {
        staticClass: "report-category__toggler",
        attrs: {
          value: _vm.open,
          disabled: _vm.category.reportsCount === 0,
          "disabled-popover": "Пустая категория",
        },
        on: {
          input: function ($event) {
            return _vm.$emit("toggle", _vm.category)
          },
        },
      }),
      _c("div", { staticClass: "report-category__data" }, [
        _c("div", { staticClass: "report-category__name" }, [
          _vm._v(" " + _vm._s(_vm.category.name) + " "),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "report-category__actions" },
        [
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  boundary: "window",
                  content: "Редактировать",
                  placement: "top",
                },
                expression:
                  "{\n        container: '#app',\n        trigger: 'hover blur',\n        boundary: 'window',\n        content: 'Редактировать',\n        placement: 'top',\n      }",
                modifiers: { html: true },
              },
            ],
            staticClass: "report-category__edit",
            attrs: { size: "iconic", icon: "edit" },
            on: {
              click: function ($event) {
                return _vm.$emit("edit", _vm.category)
              },
            },
          }),
          _vm.category.reportsCount > 0
            ? _c(
                "span",
                {
                  staticClass: "report-category__remove",
                  attrs: { id: `report-category-remove-${_vm.category.id}` },
                },
                [
                  _c("c-button", {
                    attrs: {
                      icon: { icon: "trash", color: "secondary" },
                      size: "iconic",
                      disabled: "",
                    },
                  }),
                ],
                1
              )
            : _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      boundary: "window",
                      content: "Удалить",
                      placement: "top",
                    },
                    expression:
                      "{\n        container: '#app',\n        trigger: 'hover blur',\n        boundary: 'window',\n        content: 'Удалить',\n        placement: 'top',\n      }",
                    modifiers: { html: true },
                  },
                ],
                staticClass: "report-category__remove",
                attrs: {
                  icon: { icon: "trash", color: "secondary" },
                  size: "iconic",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove", _vm.category)
                  },
                },
              }),
          _c(
            "b-popover",
            {
              attrs: {
                placement: "top",
                triggers: "hover blur",
                target: `report-category-remove-${_vm.category.id}`,
              },
            },
            [
              _c("error-feedback", {
                staticClass: "m-0 empty-category-tooltip",
                attrs: {
                  text: "В данный момент удаление невозможно, так как категория содержит данные. Сначала перенесите все данные из категории.",
                },
              }),
            ],
            1
          ),
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  boundary: "window",
                  content: "Переместить",
                  placement: "top",
                },
                expression:
                  "{\n        container: '#app',\n        trigger: 'hover blur',\n        boundary: 'window',\n        content: 'Переместить',\n        placement: 'top',\n      }",
                modifiers: { html: true },
              },
            ],
            staticClass: "report-category__move",
            attrs: { size: "iconic", icon: "arrows-constructor" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }